import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body {
        font-family: "Roboto", sans-serif;
        margin: 0 !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    html {
        scroll-behavior: smooth;
    }


    figure {
        margin-bottom: 24px;
    }

    .post-content p {
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        font-size: 18px;
        line-height: 150%;
        letter-spacing: 0;
        color: #636363;
    }


    .post-content p a {
        font-family: "Roboto", sans-serif;
        font-weight: 700;
        font-size: 18px;
        line-height: 150%;
        letter-spacing: 0;
        text-decoration: underline;
        text-decoration-style: solid;
        text-decoration-offset: 0%;
        text-decoration-thickness: 0;

        color: #0060C3;
    }

    .post-content .review-container, .features-container {
        border-radius: 5px;
    }

    .post-content picture {
        display: block;
        margin-bottom: 24px;
    }

    h1, h2, h3, h4, p {
        margin: 0;
    }

    a {
        color: none;
        text-decoration: none;
    }

    li {
        list-style: none;
    }
`;

export default GlobalStyle;
